const statusSiteUserPublisher = {
  PENDING: 1,
  REJECT: 2,
  CONFIRM: 3,
  PENDING_EDIT: 4,
  REJECT_EDIT: 5,
};

const getStatusSiteUserPublisherString = () => {
  let data = {};
  data[statusSiteUserPublisher.PENDING] = "در حال انتظار";
  data[statusSiteUserPublisher.CONFIRM] = "تایید شده";
  data[statusSiteUserPublisher.REJECT] = "رد شده";
  data[statusSiteUserPublisher.PENDING_EDIT] = "در حال انتظار ویرایش";
  data[statusSiteUserPublisher.REJECT_EDIT] = "تایید شده - آخرین ویرایش رد شده ";

  return data;
};

export default {
  statusSiteUserPublisher,
  getStatusSiteUserPublisherString,
}